export default __webpack_public_path__ + "static/media/REGIONAL_DE.311ca60e.png";